import React, { useState, useEffect } from "react";
import { DatePicker, message } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";

function HolidayTableItem(props) {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [update, setUpdate] = useState(false);
  const [change, setChange] = useState();

  const [percentage, setPercentage] = useState();
  const [active, setActive] = useState();
  const [coupon_code, setCoupon_code] = useState();
  const [value, setValue] = useState();
  const [maxValue, setMaxValue] = useState();
  const [expiry_date, setExpiry_date] = useState();
  const [id, setId] = useState();
  const [minValue, setMinValue] = useState();
  const [usage, setUsage] = useState();

  const [uminValue, setUMinValue] = useState();
  const [uusage, setUUsage] = useState();
  const [upercentage, setUPercentage] = useState();
  const [uactive, setUActive] = useState();
  const [ucoupon_code, setUCoupon_code] = useState();
  const [uvalue, setUValue] = useState();
  const [umaxValue, setUMaxValue] = useState();
  const [uexpiry_date, setUExpiry_date] = useState();
  const [uid, setUId] = useState();

  const [reason, setReason] = useState();
  const [startDate, setStartdate] = useState();
  const [endDate, setEnddate] = useState();
  const [status, setStatus] = useState();

  useEffect(() => {
    setPercentage(props.percentage);
    setActive(props.active);
    setCoupon_code(props.coupon_code);
    setValue(props.value);
    setMaxValue(props.max_value);
    setExpiry_date(props.expiry_date);
    setId(props.id);
    setMinValue(props.minValue);
    setUsage(props.usage);

    setUMinValue(props.minValue);
    setUUsage(props.usage);
    setUPercentage(props.percentage);
    setUActive(props.active);
    setUCoupon_code(props.coupon_code);
    setUValue(props.value);
    setUMaxValue(props.max_value);
    setUExpiry_date(props.expiry_date);
    setUId(props.id);

    setReason(props.reason);
    setStartdate(props.startdate);
    setEnddate(props.enddate);
    setStatus(props.status);
  
  }, []);

  const mouseover = () => {
    document.getElementById(`${props.coupon_code}`).style.backgroundColor =
      "#F0F0F0";
  };
  const mouseout = () => {
    document.getElementById(`${props.coupon_code}`).style.backgroundColor =
      "white";
  };

  const UpdateCoupon = (id) => {
    return (e) => {
      e.preventDefault();
      if (
        upercentage === undefined ||
        upercentage === -1 ||
        uactive === undefined ||
        uactive === -1 ||
        ucoupon_code === "" ||
        uvalue === "" ||
        umaxValue === "" ||
        uexpiry_date === "" ||
        uexpiry_date === null
      ) {
        message.error("Required field/s empty");
      } else {
        var axios = require("axios");

        var data = JSON.stringify({
          Percentage: upercentage ? upercentage : percentage,
          Active: uactive ? uactive : active,
          coupon_code: ucoupon_code ? ucoupon_code : coupon_code,
          Value: uvalue ? uvalue : value,
          Max_value: umaxValue ? umaxValue : maxValue,
          Expiry_Date: uexpiry_date ? uexpiry_date : expiry_date,
          min_cart_value: uminValue ? uminValue : minValue,
          usage: uusage ? uusage : usage
        });

        var config = {
          method: "put",
          url: `https://adminapi.youjifresh.com/coupons/${id}`,
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("youji_token"),
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            message.success("Coupon Updated");
            setChange(false);
            setShowModal(false);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
            message.error(error.response.data.message);
          });
      }
      setUpdate(false);
    };
  };

  const cancel = () => {
    setShowModal(false);
    setPercentage(props.percentage);
    setActive(props.active);
    setCoupon_code(props.coupon_code);
    setValue(props.value);
    setMaxValue(props.max_value);
    setExpiry_date(props.expiry_date);

    setUPercentage(props.percentage);
    setUActive(props.active);
    setUCoupon_code(props.coupon_code);
    setUValue(props.value);
    setUMaxValue(props.max_value);
    setUExpiry_date(props.expiry_date);

    if (change === true) {
      window.alert("All the changes will be discarded");

      setUPercentage(props.percentage);
      setUActive(props.active);
      setUCoupon_code(props.coupon_code);
      setUValue(props.value);
      setUMaxValue(props.max_value);
      setUExpiry_date(props.expiry_date);

      setShowModal(false);
      message.warning("Changes discarded");

      setChange(false);
    }
    setUpdate(false);
  };

  return (
    <>
      <tbody className="text-sm">
        <tr>
          <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
            <div className="flex items-center">
              <label className="inline-flex">
                <span className="sr-only">Select</span>
                <input
                  id={props.id}
                  className="form-checkbox"
                  type="checkbox"
                  onChange={props.handleClick}
                  checked={props.isChecked}
                />
              </label>
            </div>
          </td>
          <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="flex items-center text-gray-800">
              <div className="font-medium text-light-blue-500">{props.id}</div>
            </div>
          </td>
          <td
            onClick={() =>
              history.push("/updateHoliday", {
                percentage,
                upercentage,
                active,
                uactive,
                coupon_code,
                ucoupon_code,
                value,
                uvalue,
                maxValue,
                umaxValue,
                expiry_date,
                uexpiry_date,
                id,
                minValue,
                uminValue,
                usage,
                uusage,

                reason,
                startDate,
                endDate,
                status

              })
            }
            className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap cursor-pointer"
            style={{ cursor: "pointer" }}
            id={props.coupon_code}
            // onMouseOver={mouseover}
            // onMouseOut={mouseout}
          >
            <div>{props.reason}</div>
          </td>
          <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-medium text-gray-800">{props.startdate}</div>
          </td>
          <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-medium text-gray-800">{props.enddate}</div>
          </td>
          <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
            <div className="font-medium text-gray-800">{props.status ? "True":"False"}</div>
          </td>
        </tr>
      </tbody>

    
    </>
  );
}

export default HolidayTableItem;
